import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from "@material-ui/core/Typography";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
          {children}
        </div>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FrameworkPanel(props) {
  const {tabs, simplify, title = null, isSubFramework = false} = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{paddingBottom: isSubFramework ? "0px": "70px"}}>
      <Paper square elevation={isSubFramework ? 0 : 2} style={{marginTop: isSubFramework ? "1px" : "0px"}}>
      <Tabs value={value} onChange={handleChange} indicatorColor={"primary"}
            variant={simplify? "scrollable" : "fullWidth"} scrollButtons="auto"
            textColor="primary" aria-label="framework tabs" centered={true}
            style={{backgroundColor: isSubFramework ? "#fafbff": "white"}}>
        {tabs.map((tab, idx) => (
          <Tab label={tab.label} {...a11yProps(idx)} key={"tab:"+tab.label}
               style={{fontSize: isSubFramework ? "80%": "90%"}}/>
        ))}
      </Tabs>
      </Paper>
      {tabs.map((tab, idx) => (
        <TabPanel value={value} index={idx} key={"panel:"+tab.label}>
          {title !== null &&
            <div style={{textAlign: "center"}}>
              <Typography {...props} component="h5" variant="h5" style={{margin: "35px 0px 35px 0px"}}>
                {title} {tab.label}
              </Typography>
            </div>
          }
          <div style={{padding: "0px 20px"}}>
            {tab.content}
          </div>
        </TabPanel>
      ))}
    </div>
  );
}

